import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpEventType, HttpHeaders } from "@angular/common/http";

import { Observable, Subject, BehaviorSubject, from } from "rxjs";
import axios from "axios";
import { alertModal, alertModalWithoutConfirm } from "../component/helpers/alert";

@Injectable({
  providedIn: "root",
})
export class MediaService {
  media_url = environment.host + "media";
  play_list_url = environment.host + "share";
  media_upload_url = environment.host + "archive/upload";
  media_update_url = environment.host + "archive";
  additional_media_url = environment.host + "archive/additional-file/presigned-url";
  get_user_collection_url = environment.host + "archive/get-medias";
  get_public_collection_url = environment.host + "collections/public";
  get_private_collection_url = environment.host + "collections/private";
  add_media_collection_url = environment.host + "collections/add-media";
  get_collection_url = environment.host + "archive/collections";
  open_share_url = environment.host + "share/content/open";
  get_admin_collection_url = environment.host + "media/alltags";
  get_tags_url = environment.host + "common/tags";
  get_invite_collab_url = environment.host + "collaboration/invite";
  get_user_invite_req_url = environment.host + "collaboration";
  get_collection_delete_url = environment.host + "collections";
  upload_additional_file_url = environment.host + "archive/additional-file/complete-upload";

  constructor(private httpClient: HttpClient) {}

  mediaData: any[] = [];
  privateCollection: boolean;
  mediaID;
  selectedMedia;
  getUserCollection(tags, pageNum = 1, limit = 100) {
    var headers = this.get_auth_token();
    return this.httpClient.post(
      this.get_user_collection_url + `?page=${pageNum}&limit=${limit}`,
      { tags: tags },
      { ...headers }
    );
  }

getPreSignedUrls(fileName: string, totalChunks: number, fileSize: number): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
  });
  return this.httpClient.post(
    `${environment.host}archive/presigned-url`,
    { fileName, totalChunks, fileSize },
    { headers }
  );
}

completeUpload(
  mediaId: string,
  uploadId: string,
  uploadedParts: any[],
): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
  });
  return this.httpClient.post(
    `${environment.host}archive/complete-upload`,
    {
      mediaId,
      uploadId,
      parts: uploadedParts, 
    },
    { headers }
  );
}

additionalGetPreSignedUrls(mediaId: string, files: any[]): Observable<any> {
  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
  });

  return this.httpClient.post(
    `${environment.host}archive/additional-file/presigned-url
`,
    { mediaId, files }, 
    { headers }
  );
}



additionalCompleteUpload(payload: {
  files: {
    uniqueFileName: string;
    uploadId: string;
    parts: { PartNumber: number; ETag: string }[];
  }[];
}): Observable<any> {
  return this.httpClient.post( `${environment.host}archive/additional-file/complete-upload`, payload);
}



  getPublicCollection(tags, pageNum = 1, limit = 100) {
    var headers = this.get_auth_token();
    return this.httpClient.get(
      this.get_public_collection_url + `?page=${pageNum}&limit=${limit}`,

      { ...headers }
    );
  }
  getPrivateCollection(tags, pageNum = 1, limit = 100) {
    var headers = this.get_auth_token();
    return this.httpClient.get(
      this.get_private_collection_url + `?page=${pageNum}&limit=${limit}`,

      { ...headers }
    );
  }

  getAdminCollection(tags = null) {
    return this.httpClient.post(this.get_admin_collection_url, { tags: tags });
  }

  addMediaCollection(body) {
    const headers = this.get_auth_token();
    return this.httpClient.post(this.add_media_collection_url, body, {
      ...headers,
    });
  }

  getCollectionGroup() {
    var headers = this.get_auth_token();
    return this.httpClient.get(this.get_collection_url, { ...headers });
  }

  getTags(tags) {
    return this.httpClient.post(this.get_tags_url, { tag: tags });
  }

  createMedia(mediaFile) {
    var formData = new FormData();
    formData.append("file", mediaFile);
    var headers = this.get_auth_token();
    return this.httpClient.post(this.media_upload_url, formData, {
      ...headers,
      reportProgress: true,
      observe: "events",
    });
  }

  tempUploads: any[] = [];
  public tempUploads$ = new BehaviorSubject<any[]>([]);
  public mediaUploaded$ = new Subject<any>();

  markUploadSuccess(mediaId: string, fileUrl: string) {
    const card = this.tempUploads.find(c => c._id === mediaId);
    if (card) {
      card.progress = 100;
      card.isUploading = false;
      card.ogFileUrl = fileUrl; 
      this.tempUploads$.next([...this.tempUploads]);
    }
  }

  addTempUpload(card: any) {
    const index = this.tempUploads.findIndex(c => c._id === card._id);
    if (index > -1) {
      this.tempUploads[index] = { ...this.tempUploads[index], ...card };
    } else {
      this.tempUploads.push(card);
    }
    this.tempUploads$.next([...this.tempUploads]);
  }

  updateTempProgress(mediaId: string, progress: number) {
    const card = this.tempUploads.find(c => c._id === mediaId);
    if (card) {
      card.progress = progress;
      this.tempUploads$.next([...this.tempUploads]);
    }
  }

  removeTempUpload(mediaId: string) {
    this.tempUploads = this.tempUploads.filter(c => c._id !== mediaId);
    this.tempUploads$.next([...this.tempUploads]);
  }

  private getDynamicChunks(fileSize: number) {
    const CHUNK_SIZE = 10 * 1024 * 1024;
    const MIN_CHUNK_SIZE = 10 * 1024 * 1024;
    let chunks = [];
    let totalChunks = Math.ceil(fileSize / CHUNK_SIZE);

    for (let i = 0; i < totalChunks; i++) {
      let start = i * CHUNK_SIZE;
      let end = Math.min(start + CHUNK_SIZE, fileSize);

      if (
        i === totalChunks - 1 &&
        end - start < MIN_CHUNK_SIZE &&
        chunks.length > 0
      ) {
        let previousChunk = chunks.pop();
        start = previousChunk.start;
        end = fileSize;
        totalChunks--;
      }

      chunks.push({ start, end });
    }

    return { chunks, totalChunks };
  }

  private capitalizeFirstLetter(inputString: string): string {
    if (!inputString || inputString.length === 0) return inputString;
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  async startBackgroundCollectionUpload(params: {
    mediaId?: string;
    selectedFile?: File;
    additionalFiles?: File[];
    mainFileUrl?: string;
    projectFormValue: { title?: string; client_name?: string; description?: string };
    primaryTags: string[];
    customTags: string[];
    collectionTypeTag: string;
    selectedTags: string;
    playList: any[];
    collectionTags?: string;
    newCollection?: boolean;
    selectedTagId?: string;
    selectedImageUrl?: string;
  }) {
    let mediaId = params.mediaId || "";
    let fileUrl = params.mainFileUrl || "";
    const selectedFile = params.selectedFile;
    const additionalFiles = params.additionalFiles || [];

    const needMainUpload = !mediaId && selectedFile;
    const mainFileSize = (needMainUpload && selectedFile) ? selectedFile.size : 0;
    const additionalTotalSize = additionalFiles.reduce((sum, f) => sum + f.size, 0);
    const overallTotalSize = (mainFileSize + additionalTotalSize) || 1;
    let totalUploadedBytes = 0;

    const updateOverallProgress = (phaseBytes: number) => {
      const currentTotal = Math.min(totalUploadedBytes + phaseBytes, overallTotalSize);
      const progressPercent = Math.floor((currentTotal / overallTotalSize) * 100);
      if (mediaId) {
        this.updateTempProgress(mediaId, progressPercent);
      }
    };

    try {
      if (needMainUpload && selectedFile) {
        const { chunks, totalChunks } = this.getDynamicChunks(selectedFile.size);
        const presignedResp: any = await this.getPreSignedUrls(selectedFile.name, totalChunks, selectedFile.size).toPromise();
        const { uploadId, urls, mediaId: newMediaId, fileUrl: newFileUrl } = presignedResp.data;
        mediaId = newMediaId;
        fileUrl = newFileUrl;

        const tempCard = {
          _id: mediaId,
          title: params.projectFormValue["title"] || selectedFile.name,
          clientName: params.projectFormValue["client_name"] || "",
          description: params.projectFormValue["description"] || "",
          tags: params.primaryTags.concat(params.customTags),
          isPublic: params.collectionTypeTag === "public",
          extension: "." + selectedFile.name.split(".").pop()?.toLowerCase(),
          ogFileUrl: selectedFile.type.startsWith("image") ? URL.createObjectURL(selectedFile) : fileUrl,
          isUploading: true,
          progress: 0,
          uploadedBy: localStorage.getItem("username"),
          profileImg: localStorage.getItem("profileImg"),
          createdAt: new Date(),
          userId: localStorage.getItem("guestID"),
        };
        this.addTempUpload(tempCard);

        let mainUploadedParts: any[] = [];
        let chunkProgress: { [key: number]: number } = {};

        for (let i = 0; i < urls.length; i++) {
          const { partNumber, url } = urls[i];
          const chunk = selectedFile.slice(chunks[i].start, chunks[i].end);
          const res = await axios.put(url, chunk, {
            headers: { "Content-Type": "application/octet-stream" },
            onUploadProgress: (pe) => {
              if (pe.loaded) {
                chunkProgress[partNumber] = pe.loaded;
                const totalUploaded = Object.values(chunkProgress).reduce((a, b) => a + b, 0);
                updateOverallProgress(totalUploaded);
              }
            },
          });
          const eTag = res.headers["etag"]?.replace(/^"(.*)"$/, "$1");
          if (eTag) mainUploadedParts.push({ PartNumber: partNumber, ETag: eTag });

          await new Promise(resolve => setTimeout(resolve, 0));
        }

        totalUploadedBytes += mainFileSize;
        updateOverallProgress(0);

        await this.completeUpload(mediaId, uploadId, mainUploadedParts).toPromise();
      } else if (mediaId) {
        const existingTemp = this.tempUploads.find(t => t._id === mediaId);
        if (existingTemp) {
          existingTemp.isUploading = true;
          existingTemp.title = params.projectFormValue["title"] || existingTemp.title;
          existingTemp.clientName = params.projectFormValue["client_name"] || existingTemp.clientName;
          existingTemp.description = params.projectFormValue["description"] || existingTemp.description;
          existingTemp.tags = params.primaryTags.concat(params.customTags);
          existingTemp.isPublic = params.collectionTypeTag === "public";
          this.tempUploads$.next([...this.tempUploads]);
        } else {
          const tempCard = {
            _id: mediaId,
            title: params.projectFormValue["title"] || "Collection",
            clientName: params.projectFormValue["client_name"] || "",
            description: params.projectFormValue["description"] || "",
            tags: params.primaryTags.concat(params.customTags),
            isPublic: params.collectionTypeTag === "public",
            extension: selectedFile ? ("." + selectedFile.name.split(".").pop()?.toLowerCase()) : "",
            ogFileUrl: fileUrl,
            isUploading: true,
            progress: 0,
            uploadedBy: localStorage.getItem("username"),
            profileImg: localStorage.getItem("profileImg"),
            createdAt: new Date(),
            userId: localStorage.getItem("guestID"),
          };
          this.addTempUpload(tempCard);
        }
        totalUploadedBytes += mainFileSize;
        updateOverallProgress(0);
      }

      let additionalFilesData: any[] = [];
      if (additionalFiles.length) {
        const filesMeta = additionalFiles.map((file) => {
          const { totalChunks } = this.getDynamicChunks(file.size);
          return { fileName: file.name, totalChunks, fileSize: file.size };
        });

        const presignedResp: any = await this.additionalGetPreSignedUrls(mediaId, filesMeta).toPromise();
        const presignedFiles = presignedResp?.data || [];

        let additionalProgressMap: { [fileIndex: number]: number } = {};

        for (let fIndex = 0; fIndex < additionalFiles.length; fIndex++) {
          const file = additionalFiles[fIndex];
          const presignedFile = presignedFiles[fIndex];
          if (!presignedFile) continue;

          const { urls, uploadId: addUploadId, uniqueFileName } = presignedFile;
          const { chunks } = this.getDynamicChunks(file.size);

          let additionalUploadedParts: any[] = [];
          let fileChunkProgress: { [part: number]: number } = {};

          for (let cIndex = 0; cIndex < urls.length; cIndex++) {
            const { partNumber, url } = urls[cIndex];
            const chunk = file.slice(chunks[cIndex].start, chunks[cIndex].end);
            const res = await axios.put(url, chunk, {
              headers: { "Content-Type": "application/octet-stream" },
              onUploadProgress: (pe) => {
                if (pe.loaded) {
                  fileChunkProgress[partNumber] = pe.loaded;
                  const fileLoaded = Object.values(fileChunkProgress).reduce((a, b) => a + b, 0);
                  additionalProgressMap[fIndex] = fileLoaded;

                  const totalAddLoaded = Object.values(additionalProgressMap).reduce((a, b) => a + b, 0);
                  updateOverallProgress(totalAddLoaded);
                }
              },
            });

            const eTag = res.headers["etag"]?.replace(/^"(.*)"$/, "$1");
            if (eTag) additionalUploadedParts.push({ PartNumber: partNumber, ETag: eTag });

            await new Promise(resolve => setTimeout(resolve, 0));
          }

          additionalProgressMap[fIndex] = file.size;

          additionalFilesData.push({
            uniqueFileName,
            uploadId: addUploadId,
            parts: additionalUploadedParts,
          });
        }
      }

      if (additionalFilesData.length > 0) {
        await this.additionalCompleteUpload({ files: additionalFilesData }).toPromise();
      }

      const body: any = {
        title: params.projectFormValue["title"],
        clientName: params.projectFormValue["client_name"],
        description: params.projectFormValue["description"],
        tags: params.primaryTags.concat(params.customTags),
        isPublic: params.collectionTypeTag === "public",
        mediaId,
        fileType:
          params.selectedTags === "word/docs"
            ? "Word/Docs"
            : this.capitalizeFirstLetter(params.selectedTags),
        play_list: params.playList ? params.playList[0] : undefined,
      };

      if (params.collectionTags) {
        if (params.newCollection) {
          body.collectionData = {
            title: params.collectionTags,
            isPublic: params.collectionTypeTag === "public",
          };
        } else {
          body.collectionId = params.selectedTagId;
        }
      }

      this.updateMedia(body).subscribe(
        (resp: any) => {
          this.markUploadSuccess(mediaId, fileUrl);
          if (resp && resp.data) {
            this.mediaUploaded$.next(resp.data);
          }
          alertModalWithoutConfirm("success", "Successfully Uploaded!");
        },
        (err) => {
          const message = err.error?.message || "Something went wrong!";
          alertModal("error", message);
        }
      );
    } catch (err) {
      console.error("Background upload failed", err);
      alertModal("error", "Upload failed, please try again.");
    }
  }


  editMedia(mediaId: any, mediaFile: any) {
    var formData = new FormData();
    formData.append("file", mediaFile);
    var headers = this.get_auth_token();
    return this.httpClient.put(
      this.media_update_url + "/media/" + mediaId,
      formData,
      {
        ...headers,
        reportProgress: true,
        observe: "events",
      }
    );
  }

  createScreenShot(mediaFile) {
    var formData = new FormData();
    formData.append("file", mediaFile);
    var headers = this.get_auth_token();
    return this.httpClient.post(this.media_upload_url, formData, {
      ...headers,
    });
  }

  updateMedia(body: any) {
    if (body.selectedTags == "video") {
      body["selectedThumbnail"] = body.selected_thumbnail;
    }

    return this.httpClient.patch(this.media_update_url, body);
  }

  updateImage(body) {
    var headers = this.get_auth_token();

    return this.httpClient.post(this.additional_media_url, body, {
      ...headers,
    });
  }

  deleteImage(mediaId, idx) {
    return this.httpClient.patch(
      `${this.media_update_url}/additional-file/remove/`,
      { mediaId, fileId: idx }
    );
  }

  getOneByMediaId(mediaId) {
    var headers = this.get_auth_token();
    return this.httpClient.get(this.media_update_url + "/media/" + mediaId, {
      ...headers,
    });
  }

  deleteOnyById(mediaId: any) {
    var headers = this.get_auth_token();
    return this.httpClient.request("delete", this.media_update_url, {
      ...headers,
      body: { mediaId: mediaId },
    });
  }

  get_auth_token() {
    var token = localStorage.getItem("guestToken");
    var headers = {
      Authorization: "Bearer " + token,
    };
    return { headers: headers };
  }

  fileShare(phone: any, link: string) {
    let body = { phone, link };
    var headers = this.get_auth_token();
    return this.httpClient.post(this.media_url + "media/whatsapp-bot", body, {
      ...headers,
    });
  }

  playLists() {
    var headers = this.get_auth_token();
    let mockObs$: Observable<any> = from("");
    return mockObs$;
    return this.httpClient.get(this.play_list_url + "/" + "list", {
      ...headers,
    });
  }
  createPlayList(body: any) {
    var headers = this.get_auth_token();
    return this.httpClient.post(this.play_list_url, body, {
      ...headers,
    });
  }

  deletePlayList(body: any) {
    var headers = this.get_auth_token();
    return this.httpClient.delete(this.get_collection_delete_url, {
      ...headers,
      body: body,
    });
  }

  deleteCollectionPlaylist(collectionId: any) {
    var headers = this.get_auth_token();
    return this.httpClient.delete(this.get_collection_delete_url, {
      ...headers,
      body: { collectionId: collectionId },
    });
  }
  removeFromPlayList(body: any) {
    var headers = this.get_auth_token();
    return this.httpClient.delete(this.play_list_url + "/" + "remove", {
      ...headers,
      body: body,
    });
  }
  // &search=${search}
  sharePlay(body) {
    var headers = this.get_auth_token();
    return this.httpClient.post(this.play_list_url, body, {
      ...headers,
    });
  }

  sendDetails(id: any, body) {
    var headers = this.get_auth_token();
    return this.httpClient.post(`${this.play_list_url}/send/?id=${id}`, body, {
      ...headers,
    });
  }

  InvitePlayList(body, id) {
    var headers = this.get_auth_token();
    return this.httpClient.post(this.get_invite_collab_url, body, {
      ...headers,
    });
  }

  getUserInviteRequest() {
    var headers = this.get_auth_token();
    return this.httpClient.get(this.get_user_invite_req_url, {
      ...headers,
    });
  }

  acceptInvitation(body) {
    var headers = this.get_auth_token();
    return this.httpClient.post(
      `${this.get_user_invite_req_url}/accept-invite`,
      body,
      {
        ...headers,
      }
    );
  }

  rejectInvitation(body) {
    var headers = this.get_auth_token();
    return this.httpClient.post(
      `${this.get_user_invite_req_url}/reject-invite`,
      body,
      {
        ...headers,
      }
    );
  }
  accessPlayList(body) {
    var headers = this.get_auth_token();
    return this.httpClient.post(this.open_share_url, body, { ...headers });
  }

  guestPlaylist() {
    return this.httpClient.get(`${this.play_list_url}/guest-playlist`);
  }
}
